// QBE default theme

const primaryColors = [
    '#c1c9ea', // Primary10
    '#98a6dc',
    '#6d84cf',
    '#4a69c5',
    '#1d4fbb',
    '#1547b1',
    '#003da5', // Primary
    '#003399',
    '#002185', // Primary90
];

const DEFAULT_PRIMARY_COLOR = 6;

const secondaryColors = [
    '#b3e5fc', // Secondary10
    '#81d3f9',
    '#4ec2f6',
    '#28b5f5',
    '#00a8f3',
    '#009ae4', // Secondary
    '#0087d0',
    '#0076bc',
    '#00569a', // Secondary90
];

const DEFAULT_SECONDARY_COLOR = 5;

const tertiaryColors = [
    '#717d92', // Tertiary10
    '#627088',
    '#596780',
    '#4e5d78',
    '#455571',
    '#364766',
    '#283a5b',
    '#14284b', // Tertiary
    '#0a1f44', // Tertiary90
];

const DEFAULT_TERTIARY_COLOR = 7;

const greyColors = [
    '#fafbfb', // Grey10
    '#f7f8f9',
    '#f1f2f4',
    '#e1e4e8',
    '#c9ced6',
    '#b0b7c3',
    '#a7aebb', // Grey
    '#98a1b1',
    '#8a94a6', // Grey90
];

const DEFAULT_GREY_COLOR = 6;

// 3 - 9 are placeholders
const accentColors = [
    '#702f8a', // Accent1
    '#00c457',
    '#00c1cc', // Accent3

    // Not used (yet)
    '#000000', // Accent4
    '#000000',
    '#000000',
    '#000000',
    '#000000',
    '#000000', // Accent10
];

const primary = primaryColors[DEFAULT_PRIMARY_COLOR];
const secondary = secondaryColors[DEFAULT_SECONDARY_COLOR];
const tertiary = tertiaryColors[DEFAULT_TERTIARY_COLOR];
const black = '#000000';
const white = '#ffffff';
const grey = greyColors[DEFAULT_GREY_COLOR];
const success = '#00865a';
const warning = '#e0792e';
const error = '#a50000';
const backdrop = '#000000';

const color = {
    primary,
    secondary,
    tertiary,
    black,
    white,
    grey,
    success,
    warning,
    error,
    backdrop,
    ...numberedColors(primaryColors, 'primary'),
    ...numberedColors(secondaryColors, 'secondary'),
    ...numberedColors(tertiaryColors, 'tertiary'),
    ...numberedColors(greyColors, 'grey'),
    ...numberedColors(accentColors, 'accent'),
};

export default color;

/**
 * Convert an array of colors into an object whose properties follow the styled guide's color naming convention.
 *
 * @param {string[]}     colors     - array of colors (typically 9)
 * @param {string}       prefix     - color name prefix
 * @returns {object.<string>} an object that maps style guide color names to their values
 */
function numberedColors(colors, prefix) {
    return colors.reduce((acc, color, index) => Object.assign(acc, {[`${prefix}${10 * (index + 1)}`]: color}), {});
}
